import { useState } from 'react';

interface UseDragAndDropProps {
  enableDragDrop?: boolean;
  onItemDrop?: (itemId: string, folderId: string | null) => void;
}

interface UseDragAndDropReturn {
  dragOverFolderId: string | null;
  handleDragOver: (e: React.DragEvent, folderId: string | null) => void;
  handleDragLeave: (e: React.DragEvent) => void;
  handleDrop: (e: React.DragEvent, folderId: string | null) => void;
}

/**
 * Hook to manage drag and drop functionality
 */
export const useDragAndDrop = ({
  enableDragDrop = true,
  onItemDrop,
}: UseDragAndDropProps): UseDragAndDropReturn => {
  const [dragOverFolderId, setDragOverFolderId] = useState<string | null>(null);

  const handleDragOver = (e: React.DragEvent, folderId: string | null) => {
    if (!enableDragDrop || !onItemDrop) return;

    e.preventDefault();
    e.stopPropagation();
    setDragOverFolderId(folderId);
  };

  const handleDragLeave = (e: React.DragEvent) => {
    if (!enableDragDrop || !onItemDrop) return;

    e.preventDefault();
    e.stopPropagation();
    setDragOverFolderId(null);
  };

  const handleDrop = (e: React.DragEvent, folderId: string | null) => {
    if (!enableDragDrop || !onItemDrop) return;

    e.preventDefault();
    e.stopPropagation();
    setDragOverFolderId(null);

    const itemId = e.dataTransfer.getData("text/plain");
    if (itemId) {
      onItemDrop(itemId, folderId);
    }
  };

  return {
    dragOverFolderId,
    handleDragOver,
    handleDragLeave,
    handleDrop,
  };
};
